
import pro4 from "../../assets/proj4.png";
import pro7 from "../../assets/proj7.png";
import pro10 from "../../assets/proj10.png";
import pro12 from "../../assets/proj12.png";
import pro17 from "../../assets/proj17.png";
import pro20 from "../../assets/proj20.png";
import pro23 from "../../assets/design/3.jpg";
import pro40 from "../../assets/design/20.jpg";
import pro48 from "../../assets/design/28.jpg";
import pro49 from "../../assets/design/29.jpg";
import pro51 from "../../assets/certificate/1.jpg";
import pro53 from "../../assets/certificate/3.jfif";
import pro54 from "../../assets/certificate/4.jfif";
import pro55 from "../../assets/certificate/5.jfif";
import pro56 from "../../assets/certificate/6.jpg";
import pro57 from "../../assets/certificate/7.jpg";
import pro58 from "../../assets/certificate/8.png";
import pro62 from "../../assets/certificate/1695391087770.jpg";
import pro63 from "../../assets/certificate/PID-521.jpg";
import pro64 from "../../assets/certificate/14.png";
import pro65 from "../../assets/certificate/ijrsat.jpg";
import pro66 from "../../assets/certificate/1739419368587.jpg";

export const projectsData=[
    {
        id: 0,
        image: pro65,
        title: 'IJRASET Journal Certificate',
        category: 'certificate',
        link: pro65,
    },
    {
        id: 1,
        image: pro62,
        title: 'BIM Conference Certificate',
        category: 'certificate',
        link: pro62,
    },

    {
        id: 2,
        image: pro63,
        title: 'ICCIT Conference Certificate',
        category: 'certificate',
        link: pro63,
    },

    {
        id: 3,
        image: pro51,
        title: 'ICPC 2021',
        category: 'certificate',
        link: pro51,
    },


    {
        id: 4,
        image: pro66,
        title: 'ECCE Conference Certificate',
        category: 'certificate',
        link:pro66,
    },


    {
        id: 5,
        image: pro54,
        title: 'Road to corporate Workshop',
        category: 'certificate',
        link: pro54,
    },


    {
        id: 6,
        image: pro55,
        title: 'Day Long Career Bootcamp',
        category: 'certificate',
        link: pro55,
    },


    {
        id: 7,
        image: pro56,
        title: 'Job Utsob Organizer',
        category: 'certificate',
        link: pro56,
    },


    {
        id: 8,
        image: pro57,
        title: 'Take of Contes-2021 Organizer',
        category: 'certificate',
    },


    {
        id: 9,
        image: pro58,
        title: 'Net Impact Participation',
        category: 'certificate',
        link: pro58,
    },



    {
        id: 10,
        image: pro64,
        title: 'Unicef World Water Day',
        category: 'certificate',
        link: pro64,

    },

    {
        id: 11,
        image: pro4,
        title: 'Sylhet Agricultural University',
        category: 'web',
        link:"https://sau-web-new.netlify.app",
    },




    {
        id: 12,
        image: pro7,
        title: 'IOT Lab Website',
        category: 'web',
        link:'https://iotlabdiu.netlify.app',
    },





    {
        id: 13,
        image: pro10,
        title: 'Faceland Mark',
        category: 'web',
        link:'https://facelandmark.netlify.app',
    },
  

    {
        id: 14,
        image: pro12,
        title: 'Pondith Online Learners',
        category: 'web',
        link:'https://pondith-online-learners.netlify.app',
    },

    {
        id: 17,
        image: pro17,
        title: 'Resort Booking Website',
        category: 'web',
        link:'https://toxic-resort-app.netlify.app',
    },


    {
        id: 20,
        image: pro20,
        title: 'Chat Group',
        category: 'web',
        link:'https://chat-with-toxic.netlify.app'
    },



    {
        id: 23,
        image: pro23,
        title: 'Job Utsob Web Poster',
        category: 'graphics design',
        link: pro23,
    },


    {
        id: 40,
        image: pro40,
        title: '3D Large Frame',
        category: 'graphics design',
        link: pro40,
    },




    {
        id: 48,
        image: pro48,
        title: 'CDC Team Banner',
        category: 'graphics design',
        link: pro48,
    },

    {
        id: 49,
        image: pro49,
        title: 'KV Job Utsob Web Poster',
        category: 'graphics design',
        link: pro49,
    },

   

];

export const projectsNav =[
    {
        name: 'all ',
    },
    {
        name: 'certificate',
    },
    {
        name: 'web',
    },

    {
        name: 'graphics design',
    },


]